import $ from 'jquery';

require('slick-slider');

$(document).ready(() => {
	$('.hero__gallery').slick({
		arrows: false,
		fade: true,
		speed: 800,
		autoplay: true,
		autoplaySpeed: 4000,
	});
	$('.hero__spacer').bind('click', function(event){
		$('html, body').animate({ scrollTop: $(window).outerHeight() }, 1000);
	});
});



// WEBPACK FOOTER //
// ./src/js/components/hero.js